RivalIQ.module('export.collections', function (collections, App, Backbone, Marionette, $, _, moment) {

    'use strict';

    collections.Exports = Backbone.Collection.extend({
        model: function (attrs, options) {
            const spec = attrs.data.spec;

            attrs = _.extend(attrs, {
                title: spec.title
            });

            const Cls = {
                'download': RivalIQ.export.models.DownloadedReport,
                'email': RivalIQ.export.models.EmailedReport,
                'schedule': RivalIQ.export.models.ScheduledReport
            }[spec.action] || RivalIQ.export.models.Report;

            return new Cls(attrs, options);
        },

        // TODO remove. Shim for old exports w/o a spec
        parse: function (response) {
            return _.filter(response, function (attrs) {
                return _.exists(_.get(attrs, 'data.spec'));
            });
        },

        url: function () {
            const me = this;

            if (_.exists(me.reportScheduleId)) {
                return `/api/reportSchedule/${me.reportScheduleId}/exports`;
            } else {
                return `/api/landscape/${me.landscapeId}/exports`;
            }
        },

        comparator: function (model) {
            return (model.get('created_at') || moment.utc())._d * -1;
        },

        initialize: function (attrs, options) {
            const me = this;

            options = options || {};

            if (options.removeOnComplete) {
                me.listenTo(me, 'change:export_status_id', function (model) {
                    if (model.isFailed() || model.isDone()) {
                        me.remove(model);
                    }
                });
            }
        }
    });
}, window.moment);
